import React from 'react';

import {TenantUserContextType} from './types';

export const TenantUserContext = React.createContext<TenantUserContextType>({} as TenantUserContextType);

const TenantUserProvider = ({children, ...props}: React.PropsWithChildren<TenantUserContextType>) => {
    return <TenantUserContext.Provider value={props}>{children}</TenantUserContext.Provider>;
};

const useTenantUser = () => React.useContext(TenantUserContext);

export {TenantUserProvider, useTenantUser};
